import { useTranslation } from 'next-i18next';
import { FC, useMemo } from 'react';
import Button from 'src/common/components/ButtonDS22';
import { useSearchInputContext } from 'src/common/components/Search/SearchInputProvider';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import Typography from 'src/common/components/Typography';
import styles from './SheetFooter.module.scss';

const SheetFooter: FC = () => {
  const { t } = useTranslation('common');
  const {
    isSearching,
    submitSearch,
    filterDates,
    filterLocation,
    filterGuests,
    clearAll,
  } = useSearchInputContext();
  const modal = useSearchHeroModalContext();

  const noneFiltersToClear = useMemo(
    () => !filterLocation && filterDates.length === 0 && filterGuests === 0,
    [filterDates.length, filterGuests, filterLocation],
  );

  const config = useMemo(
    () => {
      if (modal.isLocationOpen) {
        return {
          left: {
            text: t('search--search-cta-skip'),
            onClick: () => modal.open('dates'),
          },
          right: {
            text: t('search--search-cta-search'),
            onClick: submitSearch,
            dataTest: 'searchButton',
          },
        };
      }
      if (modal.isDatesOpen) {
        return {
          left: {
            text: t('search--search-cta-skip'),
            onClick: () => modal.open('guests'),
          },
          right: {
            text: t('search--search-cta-next'),
            onClick: () => {
              modal.open('guests');
            },
            dataTest: 'next',

          },
        };
      }
      if (modal.isGuestsOpen) {
        return {
          left: {
            text: t('search--search-cta-clear'),
            onClick: clearAll,
            disabled: noneFiltersToClear,
          },
          right: {
            text: t('search--search-cta-search'),
            onClick: submitSearch,
            dataTest: 'searchButton',
          },
        };
      }
      return undefined;
    },
    [clearAll, modal, noneFiltersToClear, submitSearch, t],
  );

  return (
    <div className={styles.root}>
      <button
        type="button"
        onClick={() => config?.left.onClick()}
        className={styles.leftButton}
        disabled={config?.left.disabled}
      >
        <Typography
          size="body-xl"
          weight="semibold"
          type="p"
        >
          {config?.left?.text}
        </Typography>
      </button>
      <Button
        onClick={() => config?.right.onClick()}
        data-test={config?.right.dataTest}
        loading={isSearching}
      >
        {config?.right.text}
      </Button>
    </div>
  );
};
export default SheetFooter;
